export default {
  label: {
    merchantId: 'merchantNumber',
    channelName: 'Channel Name',
    api: 'api Name',
    status: 'status',
    action: 'action',
    attribute3: 'operator name',
    attribute4: 'probability',
    merchantName: 'Business Name'
  },
  status: {
    open: 'open',
    close: 'close'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/channelList.js